export interface ICommand { }

export class ConfigureConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Connectors.Commands.ConfigureConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	UpdatedBy: string
	ProviderType: string
	Config: string

	constructor (id: string, organizationUnitId: string, updatedBy: string, providerType: string, config: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.UpdatedBy = updatedBy
		this.ProviderType = providerType
		this.Config = config
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Connectors.Commands.ConfigureConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class CreateConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Connectors.Commands.CreateConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	CreatedBy: string
	Name: string
	ProviderType: string
	Config: string

	constructor (id: string, organizationUnitId: string, createdBy: string, name: string, providerType: string, config: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.CreatedBy = createdBy
		this.Name = name
		this.ProviderType = providerType
		this.Config = config
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Connectors.Commands.CreateConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class DeleteConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Connectors.Commands.DeleteConnectorCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	DeletedBy: string

	constructor (id: string, organizationUnitId: string, deletedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.DeletedBy = deletedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Connectors.Commands.DeleteConnectorCommandV1, TCh.Domain.Integrations'
	}

}

export class PermanentDeleteConnectorCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Connectors.Commands.PermanentDeleteConnectorCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Connectors.Commands.PermanentDeleteConnectorCommandV1, TCh.Domain.Integrations'
	}

}

